import styled from 'styled-components';

const ModalContent = styled.form`
  display: flex;
  flex-direction: column;
  gap: var(--space-24);
  padding: var(--space-16);
`;

const ModalButton = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: var(--space-12);
`;

export { ModalButton, ModalContent };
